import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faStop, faPlus } from '@fortawesome/free-solid-svg-icons';

class HoverEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            edit: false,
            hovered: false,
            add: false
        };

    }

    render() {
        return (
            <div
                onMouseEnter={() => this.setState({ hovered: true })}
                onMouseLeave={() => this.setState({ hovered: false })}
                style={{cursor:"default"}}
                className="clearfix"
            >
                {this.state.hovered || this.state.edit ? (
                    <div>
                        <div
                            className="pull-right"
                            style={{cursor:"pointer", marginLeft:'5px'}}
                            onClick={() => this.setState(prevState => ({ ...prevState, edit: !prevState.edit }))}
                        >
                            <FontAwesomeIcon className="text-primary" icon={faEdit} fixedWidth />
                        </div>
                        {this.props.handleDelete && this.state.edit ? (
                        <div
                            className="pull-right"
                            style={{cursor:"pointer", marginLeft:'5px'}}
                            onClick={() => {
                                this.setState(prevState => ({ ...prevState, edit: false }))
                                this.props.handleDelete(this.props.target)
                            }}
                        >
                            <FontAwesomeIcon className="text-primary" icon={faTrash} fixedWidth />
                        </div>
                        ) : null}
                        {this.props.handleStop && this.state.edit ? (
                        <div
                            className="pull-right"
                            style={{cursor:"pointer", marginLeft:'5px'}}
                            onClick={() => {
                                this.props.handleStop(this.props.target);
                                this.setState(prevState => ({ ...prevState, edit: !prevState.edit }));
                            }}
                        >
                            <FontAwesomeIcon className="text-primary" icon={faStop} fixedWidth />
                        </div>
                        ) : null}
                        {this.props.add && !this.state.edit ? (
                            <div
                            className="pull-right"
                            style={{cursor:"pointer", marginLeft:'5px'}}
                            onClick={() => {                                
                                this.setState(prevState => ({ ...prevState, add: !prevState.add }));
                            }}
                        >
                            <FontAwesomeIcon className="text-primary" icon={faPlus} fixedWidth />
                        </div>
                        ) : null}
                    </div>
                ) : null}
                {React.cloneElement(this.props.children, { 
                    edit: this.state.edit,
                    add: this.state.add,
                    editToggle: () => this.setState(prevState => ({ ...prevState, edit: !prevState.edit })),
                    addToggle: () => this.setState(prevState => ({ ...prevState, add: !prevState.add })) 
                    })}
            </div>
        );
    }
}

export default HoverEdit


// WEBPACK FOOTER //
// ./src/common/hoveredit.js